import { IItem } from "Model/Storage/IItem";
import {
  FunctionThread, Pool, spawn, Worker
} from "threads";
import { QueuedTask } from "threads/dist/master/pool-types";
import { hasNoElements } from "Utils/Array";
import { SortWorker } from "./Worker";

const pool = Pool(() => spawn<SortWorker>(new Worker(`./sortWorker.js`)), { size: 1 });

type SortTask = QueuedTask<
FunctionThread<[items: IItem[], columns: [string, boolean][], locale: string], IItem[]>,
Promise<IItem[]>
>;

let task: SortTask = null;

function cancelTask(): void {
  if (task != null) {
    task.cancel();
    task = null;
  }
}

export async function sortItems(items: IItem[], columns: [string, boolean][], locale: string): Promise<IItem[]> {
  cancelTask();

  if (hasNoElements(items)) {
    return Promise.resolve([]);
  }

  if (hasNoElements(columns)) {
    return Promise.resolve(items);
  }

  task = pool.queue((worker) => worker(items, columns, locale));
  return task;
}
